import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import Routes from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import { AuthContext } from "./components/authentication/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "./index.scss";
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <AuthContext>
        <Routes />
      </AuthContext>
      <ToastContainer autoClose={2500} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
